import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { autoCompleteIsAnytime } from '@web-platform/shared-universal-utils-frontend/src/helpers/autoCompleteIsAnytime';

import type {
  LoggedInStatusChangedAction,
  LoggedInStatusInitializedAction,
  LoginVisibilityChangedAction,
  SearchParamsChangedAction,
  TravellerSelectorViewedAction,
  ExplicitConsentGivenAction,
  CookieBannerAcknowledgedAction,
  SearchSavedAction,
  NewUserStatusChangedAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { LoginModalReferrer } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/login';
import type { PartialSearchParams } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const EXPLICIT_CONSENT_GIVEN = 'EXPLICIT_CONSENT_GIVEN';
export const LOGGEDIN_STATUS_CHANGED = 'LOGGEDIN_STATUS_CHANGED';
export const LOGIN_VISIBILITY_CHANGED = 'LOGIN_VISIBILITY_CHANGED';
export const VIEWED_TRAVELLER_SELECTOR = 'VIEWED_TRAVELLER_SELECTOR';
export const COOKIE_BANNER_ACKNOWLEDGED = 'events/COOKIE_BANNER_ACKNOWLEDGED';
export const SEARCH_PARAMS_SAVED = 'SEARCH_PARAMS_SAVED';
export const NEW_USER_STATUS_CHANGED = 'NEW_USER_STATUS_CHANGED';
export const LOGGEDIN_STATUS_INITIALIZED = 'LOGGEDIN_STATUS_INITIALIZED';

export function explicitConsentGiven(consent: boolean): ExplicitConsentGivenAction {
  return {
    type: EXPLICIT_CONSENT_GIVEN,
    payload: {
      consent,
    },
  };
}

export function loggedInStatusChanged(isLoggedIn: boolean): LoggedInStatusChangedAction {
  return {
    type: LOGGEDIN_STATUS_CHANGED,
    payload: {
      isLoggedIn,
    },
  };
}

export function loginVisibilityChanged(
  visible: boolean,
  referrer: LoginModalReferrer = null,
): LoginVisibilityChangedAction {
  return {
    type: LOGIN_VISIBILITY_CHANGED,
    payload: { referrer, visible },
  };
}

export function searchParamsChanged(searchParams: PartialSearchParams): SearchParamsChangedAction {
  return {
    type: SEARCH_PARAMS_CHANGED,
    payload: {
      searchParams: autoCompleteIsAnytime(searchParams),
    },
  };
}

export function viewedTravellerSelector(): TravellerSelectorViewedAction {
  return {
    type: VIEWED_TRAVELLER_SELECTOR,
  };
}

export function searchParamsSaved(searchState: PartialSearchParams): SearchSavedAction {
  return {
    type: SEARCH_PARAMS_SAVED,
    payload: {
      searchState,
    },
  };
}

export function searchParamsInit(searchParams: PartialSearchParams): SearchParamsChangedAction {
  return {
    type: SEARCH_PARAMS_CHANGED,
    payload: {
      searchParams,
    },
  };
}

export function cookieBannerAcknowledged(): CookieBannerAcknowledgedAction {
  return {
    type: COOKIE_BANNER_ACKNOWLEDGED,
  };
}

export function newUserStatusChanged(isNewUser: boolean): NewUserStatusChangedAction {
  return {
    type: NEW_USER_STATUS_CHANGED,
    payload: {
      isNewUser,
    },
  };
}

export function loggedInStatusInitialized(isLoggedIn: boolean): LoggedInStatusInitializedAction {
  return {
    type: LOGGEDIN_STATUS_INITIALIZED,
    payload: {
      isLoggedIn,
    },
  };
}
